import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './BrandSelectionListItem.less';

class BrandSelectionListItem extends PureComponent {
	constructor() {
		super();
		this.onClickHandler = this.onClickHandler.bind(this);
	}

	onClickHandler() {
		const { option, onSelect } = this.props;
		onSelect(option);
	}

	render() {
		const { option } = this.props;
		return (
			<li className={ styles.container } onClick={ this.onClickHandler }>
				<div className={ styles.details }>
					<div className={ styles.title }>{ option.label }</div>
					{/* <div className={ styles.desc }>{ option.value }</div> */}
				</div>
			</li>
		);
	}
}

BrandSelectionListItem.propTypes = {
	option: PropTypes.object.isRequired,
	onSelect: PropTypes.func.isRequired,
};

export default BrandSelectionListItem;
